module.exports = __webpack_public_path__ + "static/media/bannerDesktop@2x.f499f010.jpg";